module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_03_winter-cfc3f21ae5c9ce8d2eef4e5451d4576a.jpg";